import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './styles/loader.css'
import './styles/route-fade.css'
import './i18n'
import { bootstrapI18n } from './i18n/bootstrap'
import App from './App'

const root = createRoot(document.getElementById('root'))

bootstrapI18n()
  .catch((err) => {
    // First-paint with backend down: log and continue with empty
    // dictionaries (UI shows raw keys until useTranslationsQuery
    // succeeds in the background once App mounts).
    // eslint-disable-next-line no-console
    console.error('i18n bootstrap failed', err);
  })
  .finally(() => {
    root.render(
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
    )
  })
